import React, {useState} from 'react';

import styles from './productCategories.module.scss';

export default function ProductCategories({
                                              categoriesToDisplay,
                                              selectedCategories,
                                              onCategoriesUpdate
                                          }) {

    const [highlightedCategories, setHighlightedCategories] = useState(selectedCategories);

    const allCategoryItems = categoriesToDisplay
        .map(
            categoryGroup => {
                const superCategory = categoryGroup.superCategory;
                const categories = categoryGroup.categories.map(
                    category => (
                        <li key={category} className={styles.category}>
                            <button
                                className={category === selectedCategories.category ? styles.selected : ''}
                                value={category}
                                onClick={() => {
                                    const updatedCategories = {
                                        superCategory: '',
                                        category: highlightedCategories.category === category ? '' : category
                                    }
                                    setHighlightedCategories(() => updatedCategories);
                                    onCategoriesUpdate(updatedCategories);
                                }}
                            >
                                {category}
                            </button>
                        </li>
                    ));

                return (
                    <li className={styles.superCategory} key={superCategory}>
                        <button
                            className={superCategory === selectedCategories.superCategory ? styles.selected : ''}
                            onClick={() => {
                                const updatedCategories = {
                                    superCategory: highlightedCategories.superCategory === superCategory ? '' : superCategory,
                                    category: ''
                                }
                                setHighlightedCategories(() => updatedCategories);
                                onCategoriesUpdate(updatedCategories);
                            }}
                        >
                            {superCategory}
                        </button>
                        <ul className={styles.categories}>{categories}</ul>
                    </li>
                );
            });

    return (
        <ul className={`${styles.categoriesContainer} ${categoriesToDisplay.length < 5 ? styles.twoColumnLayout : ''}`}
            data-testid={'all-categories'}
        >
            {allCategoryItems}
        </ul>
    );
}